import useWebSocket, { ReadyState } from "react-use-websocket";
import { socketUrl } from "../helper";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { parseArticleKit } from "../articleKit";
import "../styles/ClientScreen.scss";

const ClientScreen = () => {
    const { code } = useParams();
    const [categories, setCategories] = useState([]);

    const onWebSocketMessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.action === "refresh-categories") {
            setCategories(data.categories);
        }
    };

    const { sendMessage, readyState } = useWebSocket(socketUrl, {
        onMessage: onWebSocketMessage,
        shouldReconnect: () => true,
    });

    useEffect(() => {
        if (readyState === ReadyState.OPEN) {
            sendMessage(JSON.stringify({
                action: "client",
                code,
            }));
        }
    }, [readyState, code, sendMessage]);

    return (
        <div className="client-screen">
            <link href="/vendor/bootstrap.min.css" rel="stylesheet" />

            <div className="articles">
                {categories.map((category, c_index) => (
                    <>
                        {category.articles.filter(article => article.amount != 0).map((article, a_index) => (
                            <div key={a_index} className="article-line">
                                <div className="article-info">
                                    <code>{article.amount}x</code>
                                    <a>{parseArticleKit(article.name).displayName}</a>
                                </div>
                                
                                <kbd>{article.price.toFixed(2)}€</kbd>
                            </div>
                        ))}
                    </>
                ))}
            </div>

            <div className="total">
                <h1>Total: <strong>{categories.reduce((acc, category) => acc + category.articles.reduce((acc, article) => acc + article.amount * article.price, 0), 0).toFixed(2)}€</strong></h1>
            </div>
            
        </div>
    )
}

export default ClientScreen